var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.html)?_c('div',{ref:"self",staticClass:"custom-code"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }